import { ref } from 'vue';
import { useAccountService } from '~/providers/account';

const productsCounts = ref<Record<TProductState, number> | undefined>();

async function loadProductsCounts() {
  const { fetchProductsCounts } = useAccountService();

  productsCounts.value = await fetchProductsCounts();
}

function getProductsCountByState(state: TProductState) {
  if (!productsCounts.value) return 0;

  return productsCounts.value[state];
}

export function useProductCounts() {
  return {
    loadProductsCounts,
    getProductsCountByState,
  };
}
